<template>
    <div class="top">
        <div class="row">
            <div class="col-md-6 d-md-flex align-items-center title">
                <h1 v-if="query" class="mr-2">
                    Tasks
                </h1>
                <h1 v-else-if="isToday" class="mr-2">
                    Today's + Past Due
                </h1>
                <h1 v-else class="mr-2">On {{ selectedDate }}</h1>
                <h5>
                    <span class="badge bg-secondary">
                        <span v-if="status == 3">Assigned To Me</span>
                        <span v-else-if="status == 4">Created By Me</span>
                        <span v-else>
                            All
                            <span v-if="taskStatus == 1">Completed</span>
                            <span v-else-if="taskStatus == 2">In Progress</span>
                            <span v-else>Open and In Progress</span>
                            Tasks
                        </span>
                    </span>
                </h5>
            </div>
            <div class="col-md-6 options">
                <div class="input-group search search-holder mr-1">
                    <input
                        v-model="searchText"
                        class="form-control col-md-6"
                        name="title"
                        placeholder="Search tasks"
                        @keyup.enter="updateText"
                    />
                    <i
                        class="fas fa-times"
                        v-if="searchText"
                        @click="clearText"
                    ></i>
                    <div class="input-group-append">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            v-b-tooltip.hover.top
                            title="Search tasks"
                            @click="updateText"
                        >
                            <i class="fas fa-search"></i>
                        </button>
                    </div>
                </div>

                <b-button-group class="mr-1">
                    <div class="btn-group input-group">
                        <button
                            class="btn btn-secondary datepickerbutton"
                            type="button"
                            v-b-tooltip.hover.top
                            title="Filter by date"
                        >
                            <i class="far fa-calendar"></i>
                        </button>
                        <date-picker
                            v-model="filterDate"
                            name="filter-date"
                            placeholder="Select date"
                            id="date-time-input"
                            :wrap="true"
                            :config="configs"
                            @dp-change="changeDate"
                        ></date-picker>
                    </div>

                    <b-button
                        @click="$emit('reload')"
                        v-b-tooltip.hover.top
                        title="Refresh"
                    >
                        <i class="fas fa-sync"> </i>
                    </b-button>
                </b-button-group>

                <button
                    type="button"
                    class="btn btn-secondary"
                    v-b-tooltip.hover.top
                    title="New Task"
                    @click="$refs.modalAddNewTask.open()"
                >
                    <span class="fas fa-plus"></span>
                </button>
            </div>
        </div>
        <modal-new-task ref="modalAddNewTask" @reload="triggerLoadList" />
    </div>
</template>
<script>
import ModalNewTask from "@/components/tasks/task-update-modal";
import { DateTime } from "luxon";

export default {
    components: { ModalNewTask },
    data() {
        return {
            searchText: null,
            filterDate: null,
            dateChange: 0,
            configs: {}
        };
    },
    mounted() {
        this.init();
        this.$root.$on("task-header-clear-search", this.clearText);
    },
    beforeDestroy: function () {
        // reset selected date
        this.$store.commit("task/setDate", null);
        this.$root.$off("task-header-clear-search", this.clearText);
    },
    computed: {
        viewTask() {
            return this.$store.getters["task/selected"];
        },
        selectedDate() {
            return this.$store.getters["task/selectedDate"];
        },
        isToday() {
            let theDate = this.$store.getters["task/selectedDate"];
            let today = this._now().toFormat(this._dateFormat);

            if (theDate) {
                return theDate == today;
            }

            return true;
        },
        status() {
            let status = this.$route.query.status;

            return status ? status : "";
        },
        taskStatus() {
            return this.$route.query.task_status;
        },
        query() {
            return this.$store.getters["task/searchText"];
        },
        userTimezone() {
            return this._timeZone;
        }
    },
    methods: {
        init() {
            this._getSetting().then(() => {
                // reformat date format based on luxon acceptable format
                const dateFormat = this.reformatDateFormat(
                    this.getDateFormat()
                );

                this.configs = {
                    allowInputToggle: true,
                    format: this.getDateFormat(),
                    defaultDate: DateTime.now()
                        .setZone(this.userTimezone)
                        .toFormat(dateFormat)
                };
            });
        },
        async changeDate() {
            this.clearText();
            this.$store.commit("task/setDate", this.filterDate);
        },
        updateText() {
            this.$store.commit("task/setSearch", this.searchText);
        },
        clearText() {
            this.searchText = null;
            this.$store.commit("task/setSearch", null);
        },
        triggerLoadList(details) {
            this.filterDate = this._carbonDateDisplay(details.date);
        },
        reformatDateFormat(format) {
            return format.replace("DD", "dd").replace("YYYY", "yyyy");
        }
    }
};
</script>
<style type="text/css" scoped>
.top {
    margin-top: 10px;
    margin-bottom: 3px;
}

.top .options {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-bottom: 6px;
}

input#date-time-input {
    visibility: hidden;
    position: absolute;
    top: 0;
}

.date-group {
    width: fit-content;
}

.search-holder {
    display: flex;
    justify-content: flex-end;
    position: relative;
}

.search-holder .fa-times {
    position: absolute;
    right: 42px;
    z-index: 10;
    top: 5px;
    padding: 6px;
    cursor: pointer;
}

.search-input {
    border-radius: 4px !important;
    height: 33px;
}

.search-holder input {
    height: 33px !important;
}
</style>
